/* eslint-disable */
import { parser, resetParserMemory } from '../../../app/services/pig-parser';
import { EVENTS } from '../../../app/constants/events';
import { DESIGNER_EVENTS } from '../../../app/constants/designer_events';

xplenty.directive('expressionEditor', [
  '$rootScope',
  '$timeout',
  '$window',
  'xplentyPigFunctions',
  'xplentyPig',
  'variables',
  'NavigationHotkeys',

  function ($rootScope, $timeout, $window, xplentyPigFunctions, xplentyPig, variables, NavigationHotkeys) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/expression-editor.html'),

      replace: true,

      scope: {},

      link(scope, element) {
        const WIDTH = 800;
        const HEIGHT = 620;

        let $scroll = element.find('.CodeMirror-scroll');
        const $editorBody = element.find('.expression-editor-body');
        const $code = element.find('.expression-editor-code');
        let $gutters = element.find('.CodeMirror-gutters');
        const $categories = element.find('.expression-editor-categories');
        const $doc = angular.element($window.document);
        let editor;
        let scrollTop = 0;
        const widgets = [];
        let avalibleVariables = {};

        $categories.on('scroll', function (event) {
          scrollTop = event.target.scrollTop;
          hideCompletionInfo();
        });

        $categories.on('mouseleave', function () {
          hideCompletionInfo();
        });

        scope.code = '';

        scope.previewTypes = [
          {
            id: 'editor',
            name: 'Editor',
            selected: true,
            active: true,
          },
          {
            id: 'console',
            name: 'X-Console',
            selected: false,
            active: true,
          },
        ];

        scope.selectPreviewType = function (currentPreviewType) {
          _.each(scope.previewTypes, function (previewType) {
            previewType.selected = false;
          });
          currentPreviewType.selected = true;
          if (currentPreviewType.id === 'console' && scope.type !== 'console') {
            $timeout(function () {
              // scope.terminal = element.find('.terminal').data('terminal');
              scope.selectTab(scope.tabs[0]);
              scope.terminal && scope.terminal.focus();
            });
          }
          scope.type = currentPreviewType.id;
        };

        scope.onTerminalCreationFn = function () {
          scope.terminal = element.find('.terminal').data('terminal');
          scope.terminal && scope.terminal.focus();
        };

        const setEditorSize = function (event, ui) {
          if (editor && editor.setSize) {
            $scroll = element.find('.CodeMirror-scroll');
            editor.setSize($code.width(), $code.height());
            $gutters.css('min-height', $code.height());
            $scroll.css('min-height', $code.height());
            $scroll.css('max-height', $code.height());
          }
          if (ui && ui.size) {
            $editorBody.height(ui.size.height - 136);
          }
        };

        element
          .draggable({
            handle: '.expression-editor-header',
            containment: 'parent',
            scroll: false,
            stop() {},
          })
          .resizable({
            containment: 'body',
            minWidth: WIDTH,
            minHeight: HEIGHT,
            create: setEditorSize,
            resize: setEditorSize,
            start: setEditorSize,
            stop: setEditorSize,
          });

        const setPosition = function () {
          element.css({
            top: ($window.innerHeight - HEIGHT) / 4,
            left: ($window.innerWidth - WIDTH) / 2,
            width: WIDTH,
            height: HEIGHT,
          });
        };

        const getPackageVariables = function (filter, callback) {
          let variablesToAdd = {};

          let currentPackage;

          if ($rootScope.getPackage) {
            currentPackage = $rootScope.getPackage();

            variablesToAdd = angular.copy((currentPackage || {}).variables || {});
          }

          const packageVariables = [];

          _.merge(variablesToAdd, filter.extraVariables);

          variables.separateVariables(variablesToAdd, {}, null, function (variablesTypes) {
            const addVariablesList = function (list, category) {
              _.each(list, function (variable, index) {
                if (filter.category === category && index >= filter.index) return;

                if (filter.category === null && variable.key.indexOf('$') !== 0) variable.key = `$${variable.key}`;

                avalibleVariables[variable.key] = true;

                const variableToAdd = {
                  itemclass: 'variable',
                  category,
                  type: 'variable',
                  help: {
                    header: `<h3>${variable.key}</h3>`,
                    body: `<p>${variable.help || category}</p>`,
                    example: `Example: ${variable.key}`,
                  },
                };

                if (
                  scope.origin ===
                  'fields-collection' /* && currentPackage && currentPackage.flow_type !== 'workflow' */
                ) {
                  variableToAdd.autocomplete = `$${variable.key}`;
                  variableToAdd.name = `$${variable.key}`;
                  variableToAdd.key = `$${variable.key}`;
                } else {
                  variableToAdd.autocomplete = variable.key;
                  variableToAdd.name = variable.key;
                  variableToAdd.key = variable.key;
                }

                packageVariables.push(variableToAdd);
              });
            };

            addVariablesList(angular.copy(variablesTypes.predefinedVariables), 'Predefined', ['Predefined']);

            if (
              filter.category === 'User' ||
              filter.category === 'System' ||
              filter.category === 'Workflow' ||
              filter.category === null
            ) {
              addVariablesList(variablesTypes.systemVariables, 'System', ['Predefined', 'System']);
            }

            if (filter.category === 'User' || filter.category === 'Workflow' || filter.category === null) {
              addVariablesList(variablesTypes.userVariables, 'User', ['Predefined', 'System', 'User']);
            }

            const schemas = $rootScope.getBaseEditorSchemas ? $rootScope.getBaseEditorSchemas() : [];

            _.each(schemas, function (schema) {
              _.each(schema.fields, function (field) {
                avalibleVariables[field.name] = true;
                packageVariables.push({
                  key: field.name,
                  name: field.name,
                  autocomplete: field.name,
                  itemclass: 'datatype',
                  category: 'Schema fields',
                  type: 'field',
                  help: {
                    header: `<h3>${field.name}</h3>`,
                    body: `<p>Schema field type [${field.data_type}].</p>`,
                    example: `Example: ${field.name}`,
                  },
                });
              });
            });

            callback(packageVariables);
          });
        };

        $rootScope.$on(EVENTS.EXPRESSION_EDITOR_SHOW, function (event, data) {
          $editorBody.removeAttr('style');

          avalibleVariables = {};

          if (!data.code) data.code = '';

          const code = data.code.trim();

          scope._default = angular.copy(code);

          scope.code = code;
          // scope.type = 'editor';

          scope.origin = data.origin;
          scope.restrictTo = data.restrictTo;
          if (scope.restrictTo === 'console') scope.selectPreviewType(_.find(scope.previewTypes, { id: 'console' }));
          else scope.selectPreviewType(scope.previewTypes[0]);

          getPackageVariables(data, function (functions) {
            xplentyPigFunctions.load();
            xplentyPigFunctions.getCategories(functions).subscribe(function (categories) {
              scope.categories = categories;

              xplentyPig.init(functions);

              scope.editorOptions = {
                lineNumbers: true,
                lineWrapping: true,
                matchBrackets: true,
                autoCloseBrackets: true,
                indentUnit: 4,
                mode: 'text/x-pig',
                showTips: true,
                showParameters: true,
                fields: [],
                tipsContainer: 'tip',
                hideTipsAfter: 5000,
                autocompleteDelay: 10,
                extraKeys: {
                  'Ctrl-Space': 'autocomplete',
                },
              };

              scope.show();
            });
          });
        });

        scope.codemirrorLoaded = function (_editor) {
          editor = _editor;
          editor.on('startCompletion', showCompletionInfo);
          editor.on('keypress', function () {
            $completionInfo.hide();
            clearErrors();
          });
          editor.on('change', function (cm) {
            const value = cm.getValue();
            scope.saveDisabled = value.length === 0;
            $completionInfo.hide();
            clearErrors();
            scope.code = value;
          });
          $timeout(function () {
            editor.focus();
            editor.setCursor(editor.lineCount(), editor.getLine(editor.lineCount() - 1).length);
          });
          $gutters = element.find('.CodeMirror-gutters');
          setEditorSize();
        };

        const $overlay = angular.element('<div class="expression-editor-overlay"></div>');
        const $body = angular.element('body');

        const bindEvents = function (e) {
          if (e.keyCode == 27) {
            if ($completionInfo.is(':visible')) $completionInfo.hide();
            else scope.hide();
          }
        };

        scope.show = function () {
          $body.append($overlay);
          setPosition();
          element.removeClass('closed');
          $doc.on('keyup', bindEvents);
          scope.editor = true;
          $rootScope.$broadcast(DESIGNER_EVENTS.TERMINAL, true);
          NavigationHotkeys.pause();
        };

        scope.hide = function () {
          $overlay.remove();
          element.addClass('closed');
          $doc.off('keyup', bindEvents);
          element[0].focus();
          hideCompletionInfo();
          scope.editor = false;
          scope.terminal && scope.terminal.reset();
          scope.terminal && scope.terminal.clear_history_state();
          scope.terminal && scope.terminal.destroy();
          scope.terminal && scope.terminal.purge();
          // reset pig parser memory (global variable)
          resetParserMemory();
          $rootScope.$broadcast(DESIGNER_EVENTS.TERMINAL, false);
          NavigationHotkeys.unpause();
          scope.reset();
        };

        scope.reset = function () {
          scope.selectTab(scope.tabs[0]);
          scope.search.name = '';
        };

        scope.save = function () {
          clearErrors();

          scope.code = editor.getValue();

          scope.selectPreviewType(scope.previewTypes[0]);

          $timeout(function () {
            try {
              parser.parse(scope.code);
              const notValidVariables = [];

              let skipNext;
              $code.find('.cm-pig-word').each(function (index, span) {
                if (skipNext) {
                  skipNext = false;
                  return;
                }
                let variable;
                const nextToken = jQuery(this).next().html();
                // fields that are generated by join components can contain '::' in their name and since code mirror treats ':' as operators and splits the tag in 2, we need to treat 2 adjacent CM tags as 1
                if (nextToken === '::') {
                  skipNext = true;
                  variable = `${span.innerText}::${jQuery(this).next().next().html()}`;
                } else {
                  variable = span.innerText;
                }
                if (!avalibleVariables[variable]) {
                  notValidVariables.push(variable);
                }
              });

              if (notValidVariables.length > 0) {
                const msg = jQuery('<div>').addClass('lint-error');
                jQuery('<span>').html('').addClass('fa fa-exclamation-triangle').prependTo(msg);
                msg.html(
                  `Parse error on line 1: \nThe following fields are not available: <strong>${notValidVariables.join(
                    ', ',
                  )}</strong>`,
                );

                widgets.push(
                  editor.addLineWidget(0, msg[0], {
                    coverGutter: false,
                    noHScroll: true,
                  }),
                );
              } else {
                $rootScope.$broadcast(EVENTS.EXPRESSION_EDITOR_SAVE, scope.code);
                scope.hide();
              }
            } catch (error) {
              const errorMessage = error.toString().split('\n');
              var line = errorMessage[0].match(/\w\sline (\d+)/i) || [];
              var line = (parseInt(line[1]) || 1) - 1;
              var msg = jQuery('<div>').addClass('lint-error');
              jQuery('<span>').html('').addClass('fa fa-exclamation-triangle').prependTo(msg);
              for (let i = 0; i < errorMessage.length; i++) {
                jQuery('<span>')
                  .html(_.escape(errorMessage[i]))
                  .css('margin-left', i == 0 ? '' : '24px')
                  .appendTo(msg);
                jQuery('<br>').appendTo(msg);
              }
              var msg = msg.get()[0];
              widgets.push(
                editor.addLineWidget(line, msg, {
                  coverGutter: false,
                  noHScroll: true,
                }),
              );
            }
          });
        };

        scope.cancel = function () {
          clearErrors();
          $rootScope.$broadcast(EVENTS.EXPRESSION_EDITOR_CLOSE);
          scope.hide();
        };

        var $completionInfo = angular.element('<div class="expression-editor-completion-info"></div>');
        const $completionInfoHeader = angular.element('<div class="expression-editor-completion-info-header"></div>');
        const $completionInfoBody = angular.element('<div class="expression-editor-completion-info-body"></div>');
        const $completionInfoExample = angular.element('<div class="expression-editor-completion-info-example"></div>');

        $completionInfo.hide();
        $completionInfo.appendTo('body');
        $completionInfoHeader.appendTo($completionInfo);
        $completionInfoBody.appendTo($completionInfo);
        $completionInfoExample.appendTo($completionInfo);

        let $hints;

        const setCompletionInfo = function (functionId) {
          const xplentyFunction = xplentyPigFunctions.get(functionId);
          if (xplentyFunction && functionId.length !== 0) {
            $completionInfoHeader.html(xplentyFunction.help.header);
            $completionInfoBody.html(xplentyFunction.help.body);
            $completionInfoExample.html(xplentyFunction.help.example);
            $completionInfo.show();
          } else {
            $completionInfo.hide();
          }
        };

        function getOffsetLeft(elem) {
          let offsetLeft = 0;
          do {
            if (!isNaN(elem.offsetLeft)) {
              offsetLeft += elem.offsetLeft;
            }
          } while ((elem = elem.offsetParent));
          return offsetLeft;
        }

        function getOffsetTop(elem) {
          let offsetTop = 0;
          do {
            if (!isNaN(elem.offsetTop)) {
              offsetTop += elem.offsetTop;
            }
          } while ((elem = elem.offsetParent));
          return offsetTop;
        }

        const initActiveHint = function (e) {
          const code = e.keyCode ? e.keyCode : e.which;
          if ($hints && $hints.length && (code == 40 || code == 38)) {
            setCompletionInfo($hints.find('.CodeMirror-hint-active').text());
          }
        };

        var showCompletionInfo = function (elem) {
          timeoutPromise && $timeout.cancel(timeoutPromise);
          var timeoutPromise = $timeout(function () {
            let position;
            let functionId;
            $body.append($completionInfo);
            if (elem instanceof CodeMirror) {
              $hints = angular.element('.CodeMirror-hints');
              if ($hints.length === 0) return;
              position = $hints.position();
              position.left += $hints.outerWidth() - 1;
              functionId = $hints.find('.CodeMirror-hint-active').text();
              $completionInfo.css(position);
              $doc.on('keydown', initActiveHint);
            } else {
              const width = elem.width();
              position = {
                left: getOffsetLeft(elem[0]) + width - 25,
                top: getOffsetTop(elem[0]) - scrollTop - 8,
              };
              $completionInfo.css(position);
              functionId = elem.text();
            }
            timeoutPromise = null;
            setCompletionInfo(functionId);
          });
        };

        var hideCompletionInfo = function () {
          $doc.off('keydown', initActiveHint);

          $completionInfo.remove();
        };

        scope.showHoverInfo = function (e) {
          const elem = $(e.target);
          showCompletionInfo(elem);
        };

        scope.hideHoverInfo = function () {
          hideCompletionInfo();
        };

        var clearErrors = function () {
          while (widgets.length > 0) {
            editor.removeLineWidget(widgets[0]);
            widgets.pop();
          }
        };

        scope.hide();

        scope.addCode = function (item) {
          if (scope.type === 'editor') {
            editor.replaceSelection(item.autocomplete || item.console /* + '()' */);
            editor.focus();
          } else if (scope.type === 'console' && scope.terminal) {
            scope.terminal.insert(item.autocomplete || item.console /* + '()' */);
            $timeout(function () {
              scope.terminal.focus();
            });
          }
        };
      },

      controller: [
        '$scope',
        '$sce',
        function ($scope, $sce) {
          $scope.saveDisabled = true;
          $scope.editor = false;

          $scope.search = {
            name: '',
          };

          $scope.tabs = [
            {
              id: 'function',
              name: 'Functions',
              active: false,
            },
            {
              id: 'variable',
              name: 'Variables',
              active: false,
            },
            {
              id: 'field',
              name: 'Fields',
              active: false,
            },
          ];

          $scope.selectTab = function (tab) {
            _.each($scope.tabs, function (_tab) {
              _tab.active = _tab.name === tab.name;
            });
            $scope.selectedTab = tab;
          };

          $scope.selectTab($scope.tabs[0]);

          $scope.filterByCategoryType = function (category) {
            return category.type === $scope.selectedTab.id;
          };

          function completeAfter(cm, pred) {
            const cur = cm.getCursor();
            if (!pred || pred()) {
              setTimeout(function () {
                if (!cm.state.completionActive) cm.showHint({ completeSingle: false });
              }, 100);
            }
            return CodeMirror.Pass;
          }

          function completeIfAfterLt(cm) {
            return completeAfter(cm, function () {
              const cur = cm.getCursor();
              return cm.getRange(CodeMirror.Pos(cur.line, cur.ch - 1), cur) == '<';
            });
          }

          function completeIfInTag(cm) {
            return completeAfter(cm, function () {
              const tok = cm.getTokenAt(cm.getCursor());
              if (
                tok.type == 'string' &&
                (!/['"]/.test(tok.string.charAt(tok.string.length - 1)) || tok.string.length == 1)
              )
                return false;
              const inner = CodeMirror.innerMode(cm.getMode(), tok.state).state;
              return inner.tagName;
            });
          }

          $scope.expandedCategories = function (category) {
            if ($scope.search.name && $scope.search.name.length > 0) {
              const items = _.filter(category.items, function (item) {
                const itemNameUppercased = item.name.toUpperCase();
                const searchNameUppercased = $scope.search.name.toUpperCase();
                return itemNameUppercased.indexOf(searchNameUppercased) > -1;
              });
              const hasItems = items.length > 0;
              if (hasItems) category.expanded = true;
              return hasItems;
            }
            return true;
          };

          $scope.highlight = function (text, search) {
            if (!search) {
              return $sce.trustAsHtml(text);
            }
            return $sce.trustAsHtml(text.replace(new RegExp(search, 'gi'), '<span class="highlighted">$&</span>'));
          };
        },
      ],
    };
  },
]);
